import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  text: {
    opacity: 0.8,
    fontStyle: 'italic',
    padding: theme.spacing(4),
  },
}));
